import { Context, Effect, Layer } from 'effect';
import * as Url from '../api/url';
import { GetSpaces } from './aspectConfigurationSpace/requests';
import { getSpacesResolver } from './aspectConfigurationSpace/resolvers';
import { AspectAuthorization } from './aspectAuthorization';
import { ConfigurationSpaces } from '../schemas/aspect/configurationSpace';
export { ConfigurationSpaces };
export class AuthError {
    originalError;
    _tag = '@fixtuur/backpack/AspectConfigurationSpaceService/AuthError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export class SpacesError {
    originalError;
    _tag = '@fixtuur/backpack/AspectConfigurationSpaceService/SpacesError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export class AspectConfigurationSpaceService extends Context.Tag('@fixtuur/backpack/AspectConfigurationService')() {
}
export class SnowflakeConfigService extends Context.Tag('@fixtuur/backpack/AspectConfig')() {
}
export const layer = Layer.effect(AspectConfigurationSpaceService, Effect.gen(function* (_) {
    const aspectAuth = yield* _(AspectAuthorization);
    const snowflakeConfig = yield* _(SnowflakeConfigService);
    const configUrl = snowflakeConfig.snowflakeUrl;
    const spacesUrl = Url.toString({
        base: configUrl.base,
        path: '/api/v1',
        query: {},
    });
    const getSpaces = (tenant) => aspectAuth.getToken(tenant).pipe(Effect.mapError(err => new AuthError(err.originalError)), Effect.flatMap(token => Effect.request(GetSpaces({ tenant, bearerToken: token }), getSpacesResolver(spacesUrl)).pipe(Effect.mapError(err => new SpacesError(err.originalError)))));
    return { getSpaces };
}));
